import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../../features/admin/ticketraise/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.ticketraise.ticketraises);
  // const all_country = useSelector((state) => state.common.all_country);
  const [name, setName] = useState("");
  console.log(country, "country");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = country?.current_page) => {
    // await dispatch(AllCountry());
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: country?.per_page,
      })
    );
  };

  return {
    country,
    name,
    setName,
    fetch,
  };
};
